// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"88d79a14","183":"4f8e0648","265":"89193029","321":"315b3261","388":"4a1dae43","415":"b961901b","782":"5c318091"}[chunkId] + ".chunk.js";
};